<div class="container">
    <div *ngIf="!isLoading">
        <pdf-viewer [src]="this.url['url']" [rotation]="0" [fit-to-page]="true" [original-size]="true" [show-all]="true" style="display: block;"></pdf-viewer>
    </div>
</div>